module.exports = __webpack_public_path__ + "static/media/beautiful-bracelet_720x480.31835d46.jpg";